import { connector } from "../../utils/common/connector";

const controller = "contract";

// ---------------------------------------------
// GET CONTRACTS BY CUSTOMER
// ---------------------------------------------
export const getContractsByCustomerService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(
      controller,
      "getContractsByCustomerId",
      params,
    );

    reply = {
      contracts: response?.contracts ?? [],
      totalContracts: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      contracts: [],
      totalContracts: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CONTRACTS BY COMPANY ORDERED
// ---------------------------------------------
export const getContractsByCompanyOrderedService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(
      controller,
      "getContractsByCompanyIdOrdered",
      params,
    );

    reply = {
      contracts: response?.contracts ?? [],
      totalContracts: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      contracts: [],
      totalContracts: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CONTRACT BY ID
// ---------------------------------------------
export const getContractByIdService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(controller, "getContract", params);

    reply = {
      contract: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      contract: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE CONTRACT
// ---------------------------------------------
export const updateContractService = async (params) => {
  let reply = { ok: false };

  try {
    const { contractId, data } = params;

    const cleanData = { ...data };
    delete cleanData._id;
    delete cleanData.companyId;

    const response = await connector.post(controller, "updateContract", {
      contractId,
      data: cleanData,
    });

    reply = {
      contract: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      contract: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE CONTRACT
// ---------------------------------------------
export const createContractService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.post(controller, "newContract", params);

    reply = {
      contract: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      contract: {},
    };
  }

  return reply;
};
